export default __webpack_public_path__ + "static/media/tech5-white-logo.19224d8a.svg";